const BrandConfig = {
  collection: "brands",
  fields: ["id", "brand", "sort"],

  filter: "filter[status][_eq]=active",

  adapter: class Brand {
    constructor(brand) {
      this.id = brand.id;
      this.brand = brand.brand;
      this.sort = brand.sort || this.id;
    }
  }
};

export default BrandConfig;
